import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'UmlPreviewCache';

/**
 * Holds UmlSchemaPreview notes — flat array on rk, same as every other
 * CacheBase2 cache in this codebase.
 */
class UmlPreviewCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns the preview note for a schema rk (title convention
     * `${schemaRk}.preview`), or null if none is cached.
     * @param {string} schemaRk
     * @returns {object|null}
     */
    getBySchemeRk = (schemaRk) => {
        try {
            this._check();
            return this._items.find((n) => n.title === `${schemaRk}.preview`) ?? null;
        } catch (error) {
            this.logError('getBySchemeRk', error.message);
            return null;
        }
    };
}

const umlPreviewCache = new UmlPreviewCache();
export default umlPreviewCache;
